module.exports = __webpack_public_path__ + "media/images/wfc/member-bg-ab6e4f9991e9dcb6130f966b04ef372b.jpg";